import { apiFetch } from "./client";

export interface ActivityEntry {
  id: string;
  companyId: string;
  action: string;
  actorType: string;
  actorId: string | null;
  agentId: string | null;
  targetType: string | null;
  targetId: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
}

export const activityApi = {
  list: (companyId: string, limit = 50) =>
    apiFetch<ActivityEntry[]>(`/activity?companyId=${companyId}&limit=${limit}`),
};
